module.exports = __webpack_public_path__ + "img/Caspian.435c195a.svg";